import tglImagesCommand from './toggleImagesCommand';
import importCommand from './openImportCommand';
import exportCommand from './openExportCommand';
const juice = require('juice');

export default function(opt = {}) {
  let editor = opt.editor;
  let cmdm = editor.Commands;
  cmdm.add(opt.cmdOpenImport, importCommand(opt));
  cmdm.add(opt.cmdTglImages, tglImagesCommand(opt));

  // Overwrite export template after the editor is loaded
  // (default commands are loaded after plugins)
  editor.on('load', () => {
    cmdm.add('export-template', exportCommand(opt));
  });

  cmdm.add('undo', {
    run(editor, sender) {
      sender.set('active', 0);
      editor.UndoManager.undo(1);
    }
  });
  cmdm.add('redo', {
    run(editor, sender) {
      sender.set('active', 0);
      editor.UndoManager.redo(1);
    }
  });
  cmdm.add('set-device-desktop', {
    run(editor) {
      editor.setDevice('Desktop');
    }
  });
  cmdm.add('set-device-tablet', {
    run(editor) {
      editor.setDevice('Tablet');
    }
  });
  cmdm.add('set-device-mobile', {
    run(editor) {
      editor.setDevice('Mobile portrait');
    }
  });

  cmdm.add('save-document', {
    run(editor, sender, opts = {}) {
      const tmpl = editor.getHtml() + `<style>${editor.getCss()}</style>`;

      let id = editor.vueEl.id
      let subject_input = editor.vueEl.subject_input
      let is_template = editor.vueEl.is_template
      let subject = subject_input.value
      let content = juice(tmpl, opts)

      editor.vueEl.$http.post(
        global.app_path + 'main.php?action=set_message',
        {
          id: id,
          subject: subject,
          content: content,
          is_template: is_template,
          token: global.token
        })
      .then(function (response) {
        let data = response.body

        if(id !== data.id) {
          console.log('id', data.id)
          editor.vueEl.$emit('update:id', data.id)
        }

        editor.vueEl.$emit('msg_update')
      },
      function (response) {

      })
    }
  });

  cmdm.add('close', {
    run(editor) {
      editor.vueEl.$emit('close')
    }
  });

  cmdm.add('nada', {
    run(editor) {

    }
  });



};
